
/* ===== VELANTIS_FINDER_HELP — botón de WhatsApp con mensaje pre-cargado ===== */
(function(){
  var msg=document.getElementById('fhMsg'), wa=document.getElementById('fhWa');
  if(!msg||!wa) return;
  var PHONE='5216629375124';
  function notasSeleccionadas(){
    return [].slice.call(document.querySelectorAll('#xfChips .xf-chip')).map(function(c){
      return c.textContent.replace(/×|✕|x/gi,'').trim();
    }).filter(Boolean);
  }
  function actualizar(){
    var base='Hola 👋, estoy en la página de Velantis y necesito ayuda para encontrar mi aroma.';
    var notas=notasSeleccionadas();
    var extra=(msg.value||'').trim();
    var texto=base;
    if(notas.length) texto+='\n\nNotas que me gustan: '+notas.join(', ')+'.';
    if(extra) texto+='\n\nLo que busco: '+extra;
    wa.href='https://wa.me/'+PHONE+'?text='+encodeURIComponent(texto);
  }
  msg.addEventListener('input',actualizar);
  wa.addEventListener('click',actualizar);   // asegura la última versión al hacer clic
  actualizar();
})();
